module.exports = __webpack_public_path__ + "img/patent1.ccd75a08.jpg";